// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__YTrKw","content":"ManualTimeModal_content__2aaQ2"};